import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Contact from '../../components/Contact/contact';
import './retreats.scss';
import Cta from '../../components/Cta/cta';

const Retreats = () => {
  const location = useLocation();

  useEffect(() => {
    if (location && location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }, [location]);
  return (
    <>
      <section id="retreats" className="retreats">
        {/* Hero Section */}
        <section className="retreats__hero py-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 mx-auto text-center">
                <h1 className="retreats__hero-title">Spiritual Retreats</h1>
                <p className="retreats__hero-subtitle">
                  Experience the perfect environment for prayer, reflection, and spiritual renewal
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Retreat Types Section */}
        <section className="retreats__types py-5">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h2 className="retreats__section-title">Our Retreat Programs</h2>
              </div>
            </div>
            
            <div className="row g-4 mt-4">
              <div className="col-lg-4 col-md-6">
                <div className="retreats__type-card">
                  <div className="retreats__card-icon">
                    <i className="fas fa-pray"></i>
                  </div>
                  <h4 className="retreats__card-title">Individual Retreats</h4>
                  <p className="retreats__card-text">
                    Personal spiritual retreats for individuals seeking quiet reflection and prayer.
                    Perfect for deepening your relationship with God in a peaceful environment.
                  </p>
                  <ul className="retreats__card-features">
                    <li>Private accommodation</li>
                    <li>Guided prayer sessions</li>
                    <li>Spiritual direction available</li>
                    <li>Flexible duration</li>
                  </ul>
                </div>
              </div>
              
              <div className="col-lg-4 col-md-6">
                <div className="retreats__type-card">
                  <div className="retreats__card-icon">
                    <i className="fas fa-users"></i>
                  </div>
                  <h4 className="retreats__card-title">Group Retreats</h4>
                  <p className="retreats__card-text">
                    Community retreats for parishes, religious groups, and organizations.
                    Strengthen bonds while growing together in faith.
                  </p>
                  <ul className="retreats__card-features">
                    <li>Shared accommodation</li>
                    <li>Group prayer sessions</li>
                    <li>Community activities</li>
                    <li>Meal services</li>
                  </ul>
                </div>
              </div>
              
              <div className="col-lg-4 col-md-6">
                <div className="retreats__type-card">
                  <div className="retreats__card-icon">
                    <i className="fas fa-calendar-alt"></i>
                  </div>
                  <h4 className="retreats__card-title">Special Events</h4>
                  <p className="retreats__card-text">
                    Seasonal retreats, workshops, and special spiritual events throughout the year.
                    Join us for unique spiritual experiences.
                  </p>
                  <ul className="retreats__card-features">
                    <li>Themed retreats</li>
                    <li>Seasonal programs</li>
                    <li>Workshop sessions</li>
                    <li>Special celebrations</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Short Retreats Section */}
        <section id="short-retreats" className="retreats__short-retreats py-5">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h2 className="retreats__section-title">One-Day & Weekend Retreats</h2>
              </div>
            </div>
            
            <div className="row g-4 mt-4">
              <div className="col-lg-6">
                <div className="retreats__short-retreat-card">
                  <h4>1-day Retreats and Workshop</h4>
                  <p className="price">R 300.00</p>
                  <p>Includes: 2 teas & lunch</p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="retreats__short-retreat-card">
                  <h4>Weekend Retreats</h4>
                  <p className="price">R 1,800.00</p>
                  <p>Friday supper 18:00 – after lunch on Sunday</p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="retreats__short-retreat-card">
                  <h4>1-day Retreats and Workshop</h4>
                  <p className="price">R 100.00</p>
                  <p>Bring & Share lunch</p>
                  <p>Tea / Coffee provided</p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="retreats__short-retreat-card">
                    <h4>Day Retreats</h4>
                    <p>9:00am – 14:00pm</p>
                    <p>Take a day for yourself to reconnect and find peace. Ideal for a mid-week spiritual refresh.</p>
                    <p>Contact us for booking and pricing details.</p>
                </div>
              </div>
            </div>

            <div className="row mt-5">
                <div className="col-lg-8 mx-auto">
                    <div className="retreats__booking-info">
                        <h4>Booking Information</h4>
                        <p>When booking your retreat please pay your deposit within two weeks as confirmation, otherwise the place cannot be kept open for you.</p>
                        <p>If you make an EFT payment, please notify us & indicate the name/s of retreatant/s.</p>
                    </div>
                </div>
            </div>
          </div>
        </section>

        {/* Long Retreats Information Section */}
        <section id="long-retreats" className="retreats__long-retreats-info py-5">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <h2 className="retreats__section-title">Long Retreats</h2>
                    </div>
                </div>
                
                <div className="row g-4 mt-4">
                    <div className="col-lg-6">
                        <div className="retreats__info-card">
                            <h4>Pricing</h4>
                            <p><strong>8-day Directed Retreat:</strong></p>
                            <p className="price">R 10,000.00</p>
                            <p><strong>8-day Preached Retreat:</strong></p>
                            <p className="price">R 9,000.00</p>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="retreats__info-card">
                            <h4>Deposit</h4>
                            <p>A non-refundable deposit of <strong>R800.00</strong> is required as confirmation of your booking for the Live-in Retreats.</p>
                            <p><em>If we cancel the retreat your deposit will be returned.</em></p>
                        </div>
                    </div>
                </div>

                <div className="row mt-5">
                    <div className="col-lg-10 mx-auto">
                        <div className="retreats__notes-card">
                            <h4>Please Note for Live-in Retreats</h4>
                            <ul>
                                <li>Retreats begin at 18:00 with supper and end after breakfast on the last day.</li>
                                <li>When booking your retreat please pay your deposit within two weeks as confirmation, otherwise the place cannot be kept open for you.</li>
                                <li>DEPOSIT – A non-refundable deposit of R900.00 is required as confirmation of your booking for the Live-in Retreats & R300.00 for the Online Retreats. This will be deducted upon full payment</li>
                                <li><strong>ONLY BOOKINGS VIA EMAIL WILL BE CONSIDERED</strong></li>
                                <li>Final payment must be paid 2 weeks before your retreat.</li>
                                <li>If you make an EFT payment, please notify us & indicate the name/s of retreatant/s, not only the congregation.</li>
                                <li>Cash payments into our Bank require a surcharge of an extra R50.00</li>
                                <li>Transport to or from the airport or Station can be arranged for an additional fee.</li>
                                <li>We have contact with a reliable Taxi. If you need Transport, please let us know at least 2 weeks before the retreat starts and we can do the bookings for you.</li>
                                <li>Please bring your own TORCH as load shedding seems to be part of life. We provide green soap for washing, please bring your own soap powder.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        {/* Directed Retreats Info Section */}
        <section id="directed-retreats" className="retreats__directed-info py-5">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 mx-auto text-center">
                        <h2 className="retreats__section-title">Directed Retreats</h2>
                        <div className="retreats__info-card-dark">
                            <p>Anyone wishing to have a directed Retreat outside the given times, please book during the time of a Preached Retreat. One of the sisters will be available during this period.</p>
                            <p>Private Directed Retreats are possible at other times. However, the Tariff differs from the Group Directed Retreat.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        {/* Online Retreats & Spiritual Direction Section */}
        <section id="online-spiritual" className="retreats__online-spiritual py-5">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <h2 className="retreats__section-title">Online Retreats & Spiritual Direction</h2>
                    </div>
                </div>
                <div className="row g-4 mt-4 justify-content-center">
                    <div className="col-lg-6">
                        <div className="retreats__info-card">
                            <h4>Online Retreats</h4>
                            <p>If you would like to have the convenience of an Online Retreat, this can be arranged on an individual basis with Sr Pru.</p>
                            <p>A non-refundable deposit of <strong>R250.00</strong> is required for Online Retreats. This will be deducted upon full payment.</p>
                            <p className="price">R 300 per session</p>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="retreats__info-card">
                            <h4>Spiritual Direction</h4>
                            <p>Spiritual direction is available by request.</p>
                            <p className="price">R 300 per session</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        {/* Facilities Section */}
        <section className="retreats__facilities py-5">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h2 className="retreats__section-title">Retreat Facilities</h2>
              </div>
            </div>
            
            <div className="row g-4 mt-4">
              <div className="col-lg-6">
                <div className="retreats__facility-item">
                  <div className="retreats__facility-icon">
                    <i className="fas fa-bed"></i>
                  </div>
                  <div className="retreats__facility-content">
                    <h4>Comfortable Accommodation</h4>
                    <p>Clean, comfortable rooms with private bathrooms. Single and shared options available.</p>
                  </div>
                </div>
              </div>
              
              <div className="col-lg-6">
                <div className="retreats__facility-item">
                  <div className="retreats__facility-icon">
                    <i className="fas fa-utensils"></i>
                  </div>
                  <div className="retreats__facility-content">
                    <h4>Dining Services</h4>
                    <p>Nutritious meals prepared with care. Special dietary requirements can be accommodated.</p>
                  </div>
                </div>
              </div>
              
              <div className="col-lg-6">
                <div className="retreats__facility-item">
                  <div className="retreats__facility-icon">
                    <i className="fas fa-church"></i>
                  </div>
                  <div className="retreats__facility-content">
                    <h4>Chapel & Prayer Spaces</h4>
                    <p>Beautiful chapel for communal prayer and private prayer rooms for individual reflection.</p>
                  </div>
                </div>
              </div>
              
              <div className="col-lg-6">
                <div className="retreats__facility-item">
                  <div className="retreats__facility-icon">
                    <i className="fas fa-leaf"></i>
                  </div>
                  <div className="retreats__facility-content">
                    <h4>Peaceful Grounds</h4>
                    <p>Serene gardens and outdoor spaces perfect for meditation and contemplation.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Cta 
          title="Ready to Experience St. Dominic's<br />House of Prayer?"
          subtitle="Book your retreat today and discover the perfect place for spiritual reflection and community connection."
          primaryButton={{ 
            text: 'Long retreat brochure',
            onClick: () => window.open('/long-retreat.pdf', '_blank')
          }}
          secondaryButton={{ 
            text: 'Short retreat brochure',
            onClick: () => window.open('/short-retreat.pdf', '_blank')
          }}
        />
      </section>

      {/* Contact Section */}
      <Contact />
    </>
  );
};

export default Retreats; 